import React from "react";
import "./style.css";
import {
  FaInstagram
} from "react-icons/fa";
import { followLink, socialprofils } from "../../content_option";

export const Socialicons = (params) => {
  return (
    <div className="stick_follow_icon">
      <ul>
        {socialprofils.instagram && (
          <li>
            <a href={socialprofils.instagram} target='_blank' rel="noreferrer">
              <FaInstagram />
            </a>
          </li>
        )}
      </ul>
      <p>{followLink.text}</p>
    </div>
  );
};
